import OutputNodeType from './OutputNodeType'

export default OutputNodeType
